import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  background-color: #fff !important;
  min-height: 93vh;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

export const StyledTypography = styled(Typography)`
  font-weight: 500 !important;
  color: #838ea4 !important;
`;

export const StyledGrid = styled(Grid)`
  border-left: 1px solid #e7e8ed;
  padding: 0 10px;
`;
